module.exports = __webpack_public_path__ + "img/19.db8a2b71.jpeg";